module.exports = __webpack_public_path__ + "static/img/MK.3e58f573.svg";